import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { RichBanner, ContentBanner, Banner } from '@grandvisionhq/content';
import { Heading } from '@grandvisionhq/elements';
import { compose } from '@grandvisionhq/utils';
import { ProductListingRowWrapper } from '../../components/ProductListingRow/ProductListingRowWrapper.js';
import { RichBannerCampaignContainer } from '../../components/RichBannerCampaign/RichBannerCampaignContainer.js';
import { withAnchor } from '../../hocs/with-anchor.js';
import { withBloomreachData } from '../../hocs/with-bloomreach-data.js';
import '@grandvisionhq/state';
import '@bloomreach/react-sdk';
import '../../context/configuration.js';
import '@bloomreach/spa-sdk';
import '@grandvisionhq/search';
import 'jsonpointer';
import '@grandvisionhq/common';
import '../../utils/http-client.js';
import { parseBloomreachImage } from '../../utils/parse-bloomreach-image.js';
import { useBloomreachLinks } from '../../hooks/use-bloomreach-links.js';
import '@grandvisionhq/lib-utils-html';
import '@grandvisionhq/graphql';
import '../../operations/mutations/signup-promotion.js';
import '../../operations/mutations/subscribe-newsletter.js';
import '../../operations/mutations/subscribe-newsletter-opt-in.js';
import '@grandvisionhq/svc-tealium/events';
import '../../hooks/use-breakpoint-visibility.js';
import { withBreakpointVisibility } from '../../hocs/with-breakpoint-visibility.js';
import { withEditableContent } from '../../hocs/with-editable-content.js';

const CmsBanner = ({ content , template , meta  })=>{
    var ref;
    const { title , description , content: richText , titleSemantic  } = content;
    const links = useBloomreachLinks(content.links);
    const image = parseBloomreachImage(content.image);
    const tooltip = ((ref = content.tooltip) === null || ref === void 0 ? void 0 : ref.showTooltip) ? content.tooltip : undefined;
    switch(template){
        case 'full-width':
            return /*#__PURE__*/ React.createElement(Banner, {
                image: image === null || image === void 0 ? void 0 : image.original,
                mobileImage: image === null || image === void 0 ? void 0 : image.mobile,
                link: links[0],
                tooltip: tooltip
            });
        case 'contained-banner':
            return /*#__PURE__*/ React.createElement(Banner, {
                image: image === null || image === void 0 ? void 0 : image.original,
                mobileImage: image === null || image === void 0 ? void 0 : image.mobile,
                link: links[0],
                useContainer: true,
                tooltip: tooltip
            });
        case 'top-banner':
            return /*#__PURE__*/ React.createElement(Banner, {
                image: image === null || image === void 0 ? void 0 : image.original,
                mobileImage: image === null || image === void 0 ? void 0 : image.mobile,
                link: links[0],
                useContainer: true,
                useLazyLoading: false,
                tooltip: tooltip
            });
        case 'content-banner':
            return /*#__PURE__*/ React.createElement(ContentBanner, {
                image: image === null || image === void 0 ? void 0 : image.original,
                mobileImage: image === null || image === void 0 ? void 0 : image.mobile,
                links: links,
                title: title,
                text: description,
                textColor: meta.textColor,
                tooltip: tooltip,
                titleSemantic: titleSemantic,
                bannerHeight: meta.bannerHeight
            });
        case 'rich-banner':
            var ref1;
            const products = (ref1 = content === null || content === void 0 ? void 0 : content.products) !== null && ref1 !== void 0 ? ref1 : [];
            return /*#__PURE__*/ React.createElement(RichBanner, swcHelpers.extends({}, meta, {
                image: image === null || image === void 0 ? void 0 : image.original,
                mobileImage: image === null || image === void 0 ? void 0 : image.mobile,
                richText: richText === null || richText === void 0 ? void 0 : richText.value,
                link: links.find((l)=>l.style === 'image'
                ),
                tooltip: tooltip,
                backgroundColor: (meta === null || meta === void 0 ? void 0 : meta.backgroundColorHex) || (meta === null || meta === void 0 ? void 0 : meta.backgroundColor)
            }), /*#__PURE__*/ React.createElement(ProductListingRowWrapper, {
                skus: products,
                limit: 2
            }));
        case 'rich-banner-with-campaign':
            if (!content.campaignId) {
                return /*#__PURE__*/ React.createElement(Heading, {
                    variant: "subheading1"
                }, "Campaign Banner rendered without campaignId - please add it in BloomReach.");
            }
            return /*#__PURE__*/ React.createElement(RichBannerCampaignContainer, swcHelpers.extends({}, meta, {
                campaignId: content.campaignId,
                image: image === null || image === void 0 ? void 0 : image.original,
                mobileImage: image === null || image === void 0 ? void 0 : image.mobile,
                richText: richText === null || richText === void 0 ? void 0 : richText.value,
                link: links.find((l)=>l.style === 'image'
                )
            }));
        default:
            return /*#__PURE__*/ React.createElement(Heading, {
                variant: "subheading1"
            }, "Banner with template: ", template, " is not defined in CmsBanner component.");
    }
};
var CmsBanner$1 = compose(withBreakpointVisibility, withBloomreachData, withEditableContent, withAnchor)(CmsBanner);

export { CmsBanner, CmsBanner$1 as default };
//# sourceMappingURL=Banner.js.map
